import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { find, propEq } from 'ramda';
import { Button, Form } from 'antd';
import Translate from 'react-translate-component';
import { connect } from 'react-redux';

import { openModalDocument } from 'actions/modalActions';
import { tailFormItemLayout } from 'constants/formItemLayout';
import { required } from 'utils/validators';
import Select from 'components/common/form/Select';

@connect(null, { openModalDocument })
export default class EventDocumentPickField extends Component {
    static propTypes = {
        documentsList: PropTypes.array.isRequired,
        form: PropTypes.object.isRequired,
        openModalDocument: PropTypes.func.isRequired,
        type: PropTypes.string,
        dockey: PropTypes.string,
    };

    componentDidMount() {
        this.props.form.change('result.type', this.props.type);
    }

    openModalDocument = () => {
        const { documentsList, dockey } = this.props;
        const doc = find(propEq('id', Number(dockey)), documentsList);

        if (doc) {
            this.props.openModalDocument(doc);
        }
    }

    render() {
        const { documentsList, dockey } = this.props;

        return (
            <Fragment>
                <Field
                    name='result.dockey'
                    component={Select}
                    options={documentsList}
                    validate={required}
                    namePath='name'
                    valuePath='id'
                    label={{ content: 'events.documentPick', required: true }}
                    required={true}
                />
                { dockey && (
                    <Form.Item {...tailFormItemLayout}>
                        <Button onClick={this.openModalDocument}>
                            <Translate content='documents.review' />
                        </Button>
                    </Form.Item>
                )}
            </Fragment>
        );
    }
}
